import { isInIframe } from '@telecom/shared/utils/in-iframe';
import { OpenNewTask } from '../open-new-task';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { RouterService } from '@telecom/shared/services/router';
import { generateUUID } from '@telecom/shared/utils/uuid';

@injectable()
export class OpenNewTaskImpl implements OpenNewTask {
    constructor(
        @inject(RouterService)
        private readonly _routerService: RouterService,
    ) {}

    open(name: string, taskId?: string): void {
        if (isInIframe()) {
            this._openInIframe(name, taskId);
        } else {
            this._openInNewTab(name, taskId);
        }
    }

    get win() {
        return isInIframe() ? window.parent : window;
    }

    private _createTaskId(taskId?: string): string {
        return taskId || generateUUID();
    }

    private _openInIframe(name: string, taskId?: string): void {
        this.win.open(`/ai-drafting/${name}/${this._createTaskId(taskId)}`, '_blank');
    }

    private _openInNewTab(name: string, taskId?: string): void {
        const resolvedTaskId = this._createTaskId(taskId);
        const target = name === 'hiro'
            ? { name, params: { id: resolvedTaskId } }
            : { name, query: { taskId: resolvedTaskId } };
        const { href } = this._routerService.resolve(target);
        this.win.open(href, '_blank');
    }
}
